import { Divider, Typography, XStack, YStack } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'

import * as Styled from './styles'

interface LabelValueRowProps {
  label: string | undefined
  value: string | string[] | undefined
}

export const LabelValueRow = ({ label, value }: LabelValueRowProps) => {
  const valueLines = Array.isArray(value) ? value : [value]
  const rowKeyPrefix = label ?? 'value'

  return (
    <YStack>
      <YStack padding={12}>
        <XStack align="flex-start" justify="space-between">
          <Styled.LabelValueRowLabel>
            <Typography.Text color={colors.content.neutral.medium} size="small" weight="medium">
              {label}
            </Typography.Text>
          </Styled.LabelValueRowLabel>
          <Styled.LabelValueRowValue>
            {valueLines.map((line, index) => (
              <div key={`${rowKeyPrefix}-${index}`}>
                <Typography.Text color={colors.content.neutral.strong} size="small" weight="medium">
                  {line}
                </Typography.Text>
              </div>
            ))}
          </Styled.LabelValueRowValue>
        </XStack>
      </YStack>
      <Divider size="extra-small" visibility="low" />
    </YStack>
  )
}
